<template>
    <Popup ref="popup" :animation="'scale'" >
        <div class="payment-cont" :style="landscapeScale < 1 ? { transform: `scale(${landscapeScale})` } : {}">
            <img class="payment-bg" :src="_global.assetsRoot + '/common/pop_payment_bg.png'" />
            <div class="content" >
                <div class="close t-r v-m" >
                    <img class="v-m btn" :src="_global.assetsRoot + '/common/pop_btn_close.png'" @click.stop="cancel" />
                </div>
                <div class="payment-body" >
                   <img class="title-img" :src="_global.assetsRoot + `/common/payment_title_${_i18n.locale}.png`" />
                    <span class="payment-subtitle beba" >{{ $t("message.paymentSubTitle") }}</span>
                    <div class="btn pix-btn" @click.stop="gotoPayment('fix')" >
                        <!--img :src="_global.assetsRoot + '/common/payment_btn_pix.png'" /-->
                        <span class="beba" >{{ $t("message.pix") }}</span>
                    </div>
                    <div class="btn other-ways" @click.stop="gotoPayment(null)" >
                        <span class="beba" v-html="$t('message.otherWays')" ></span>
                    </div>                    <div class="secure-payment">
                        <img :src="_global.assetsRoot + '/common/pop_payment_icon_safe.png'" />
                        <span class="beba">{{ $t('message.securePaymentText') }}</span>
                    </div>                </div>
            </div>
        </div>
    </Popup>
</template>

<script>
import Popup from '../Popup.vue'

var hostname = window.location.hostname;
const paymentHost = hostname == 'store.drbingo.com' ? 'https://www.drbingo.com' : hostname == 'store.doutorbingo.com' ? 'https://pay.doutorbingo.com' : 'https://staging.doutorbingo.com';

export default {
    props: {
        paymentId: String
    },
    data() {
        return {
            handle: null,
            landscapeScale: 1
        }
    },
    methods: {
        show() { 
            if (window.innerWidth > window.innerHeight) {
                this.landscapeScale = Math.min((window.innerHeight * 0.85) / (window.innerWidth * 0.7), 1);
            } else {
                this.landscapeScale = 1;
            }
            this.$refs.popup.show() 
        },
        cancel() {
            this.$emit("onhide")
            this.hide();
        },
        hide() { this.$refs.popup.hide() },
        gotoPayment(type) {
            this.$emit("payment")
            this.handle = window.open(`${paymentHost}/pay.htm?platform=secret&paymentId=${this.paymentId}${type ? `&type=fix`: ''}`);
        }
    },
    components: { Popup }
}
</script>

<style lang="scss" >
@import "../../assets/css/variables.scss";
.payment-cont {
    position: relative;
    width: 75vw;
    margin: 0 auto;
    transform-origin: center center;

    .payment-bg {
        width: 100%;
    }

    .content {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        display: flex;
        flex-direction: column;

        .close {
            position: absolute;
            top: -3vw;
            right: -2vw;
            z-index: 10;
            width: 7vw;
            height: 7vw;

            img {
                width: 100%;
                height: 100%;
                cursor: pointer;
            }
        }

        .payment-body {
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 3vw;
            text-align: center;

            .title-img {
                width: 100%;
                position: absolute;
                top: 2rem;
                left: 0;
                z-index: 5;
                scale: .9;
            }

            .payment-title {
                display: block;
                color: #FFF;
                font-size: 5vw;
                font-weight: bold;
                text-shadow:
                    -2px -2px 0 #2d2e81,
                    0px -2px 0 #2d2e81,
                    2px -2px 0 #2d2e81,
                    -2px  0px 0 #2d2e81,
                    2px  0px 0 #2d2e81,
                    -2px  2px 0 #2d2e81,
                    0px  2px 0 #2d2e81,
                    2px  2px 0 #2d2e81;
            }

            .payment-subtitle {
                display: block;
                color: #FFF;
                line-height: 4vw;
                opacity: 0.85;
                font-size: 4vw;
                font-weight: bold;
                margin-top: 25px;
                text-shadow:
                    -2px -2px 0 #2641bf,
                    0px -2px 0 #2641bf,
                    2px -2px 0 #2641bf,
                    -2px  0px 0 #2641bf,
                    2px  0px 0 #2641bf,
                    -2px  2px 0 #2641bf,
                    0px  2px 0 #2641bf,
                    2px  2px 0 #2641bf;
            }

            .btn {
                display: flex;
                align-items: center;
                justify-content: center;
                height: 12vw;
                width: 56vw;
                cursor: pointer;

                span {
                    color: #FFF;
                }
            }

            .pix-btn {
                background: url($assetRoot + "/common/payment_btn_pix.png") center no-repeat;
                background-size: 100% 100%;
                justify-content: flex-end;

                img {
                    height: 60%;
                    margin-right: 1vw;
                }

                span {
                    color: #295651;
                    font-size: 4vw;
                    font-weight: bold;
                    margin-right: 10vw;
                }
            }

            .other-ways {
                background: url($assetRoot + "/common/payment_btn_credit.png") center no-repeat;
                background-size: 100% 100%;
                box-sizing: border-box;
                justify-content: flex-start;

                span {
                    color: #46387b;
                    font-size: 4vw;
                    font-weight: bold;
                    margin-left: 12vw;
                }
            }

            .secure-payment {
                display: flex;
                align-items: center;
                gap: 1.5vw;
                padding: 0 14vw;
                text-align: justify;

                img {
                    width: 6vw;
                    height: 6vw;
                    flex-shrink: 0;
                }

                span {
                    color: #FFF;
                    font-size: 2.5vw;
                    font-weight: bold;
                    line-height: 4vw;
                    text-shadow:
                        -2px -2px 0 #2641bf,
                        0px -2px 0 #2641bf,
                        2px -2px 0 #2641bf,
                        -2px  0px 0 #2641bf,
                        2px  0px 0 #2641bf,
                        -2px  2px 0 #2641bf,
                        0px  2px 0 #2641bf,
                        2px  2px 0 #2641bf;
                }
            }
        }
    }
}

/* .mobile override removed — use vw-based responsive base styles above */
</style>



// WEBPACK FOOTER //
// src/components/popup/Payment.vue